import { Option } from 'funfix-core';
import React from 'react';
import { ANALYTICS_MODAL_UPGRADE } from '../../../../analytics/Sources';
import { foldInstallStatus, isInstallStatusLoading } from '../../../../records/InstallMode/InstallStatus';
import { getErrorDetails } from '../../../../utils/request-utils';
import ExternalMarketplaceLink from '../common/ExternalMarketplaceLink';
import InstallableAppPrivacyInformation from '../common/InstallableAppPrivacyInformation';
import DialogUpgradeContent from './DialogUpgradeContent';
import DialogUpgradeFooter from './DialogUpgradeFooter';
import { jsx as _jsx } from "react/jsx-runtime";
const resolveDialogUpgrade = _ref => {
  let {
    closeInstallDialog,
    context,
    hostConfig,
    links,
    scopesLookup,
    upgradeApp,
    upgradeInstallMode
  } = _ref;
  return {
    analyticsSourceModal: ANALYTICS_MODAL_UPGRADE,
    content: /*#__PURE__*/_jsx(DialogUpgradeContent, {
      installableAppToUpgradeTo: upgradeInstallMode.installableAppToUpgradeTo,
      links: links,
      scopesLookup: scopesLookup
    }),
    heading: 'App update',
    footerLeft: upgradeInstallMode.installableAppToUpgradeTo.flatMap(ia => ia.toOption()).map(installableAp =>
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-key
    _jsx(ExternalMarketplaceLink, {
      context: context,
      links: links,
      marketplaceAppDetails: installableAp.marketplaceAppDetails
    })).getOrElse(),
    footerCenter: upgradeInstallMode.installableAppToUpgradeTo.flatMap(ia => ia.toOption()).map(ia =>
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-key
    _jsx(InstallableAppPrivacyInformation, {
      context: context,
      installableAppId: upgradeInstallMode.installableAppByKeyId,
      marketplaceAppDetails: ia.marketplaceAppDetails
    })).getOrElse(),
    footerRight: /*#__PURE__*/_jsx(DialogUpgradeFooter, {
      closeInstallDialog: closeInstallDialog,
      context: context,
      hostConfig: hostConfig,
      upgradeApp: upgradeApp,
      upgradeInstallMode: upgradeInstallMode
    }),
    preventDialogClosing: isInstallStatusLoading(upgradeInstallMode.status),
    errorDetails: foldInstallStatus(upgradeInstallMode.status, () => Option.empty(), () => Option.empty(), complete => complete.result.fold(error => Option.some(getErrorDetails(error, hostConfig)), () => Option.empty()))
  };
};
export default resolveDialogUpgrade;